<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lTycFT/OEBPS/images/9780316076012_cover.jpg?1733067579626" alt="This image is the cover for the book Tracking the Tempest, Jane True Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tracking the Tempest, Jane True Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Valentine's Day is fast approaching, and Ryu -- Jane's bloodsucking boyfriend -- can't let a major holiday go by without getting all gratuitous. An overwhelming dose of boyfriend interference and a last-minute ticket to Boston later, and Jane's life is thrown off course.<br/><br/>Ryu's well-intentioned plans create mayhem, and Jane winds up embroiled in an investigation involving a spree of gruesome killings. All the evidence points towards another Halfling, much to Jane's surprise. . .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicole Peeler
      </h2>
      
      <p class="authorDescription body article"><B>Nicole Peeler</B> writes urban fantasy and is an associate professor at Seton Hill University, where she co-directs their MFA in Writing Popular Fiction. She is the author of the award-winning Jane True series and <I>Jinn and Juice</I>, the first book in a series about a cursed jinni living in Pittsburgh. Nicole also lives in Pittsburgh, although she's neither cursed nor a jinni.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?440ad0c8